import * as runtypes from 'runtypes';
import * as institutionSeed from 'src/models/institutionSeed';

export const InstitutionSeedRecord = runtypes.Dictionary(institutionSeed.types.InstitutionSeed, runtypes.String);

export type InstitutionSeedRecord = runtypes.Static<typeof InstitutionSeedRecord>;
